import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from 'my-lib-sanfelici';

@Component({
  selector: 'app-auth-details',
  templateUrl: './auth-details.component.html',
  styleUrls: ['./auth-details.component.scss']
})
export class AuthDetailsComponent implements OnInit {
usr: Observable<firebase.User>;
  constructor(
    private route: ActivatedRoute,
    private authservice: AuthService) { }

  ngOnInit() {
const id = this.route.snapshot.params.id;
this.usr = this.authservice.get(id);
  }

}
